export default __webpack_public_path__ + "static/media/dotedLine.69ff5b88.svg";